module.exports = __webpack_public_path__ + "media/images/affinity_logo_white-84247af9e1afeef69350e3b402a02f65.svg";